import SharedStorageInterface from "../SharedStorageInterface.js";

/*
    this mock was created so that we can just use the persister.

    because cisobot-webapp only needs to set/persist some values for the comp webapp (at the moment), 
    which is done through the persist decorator
*/
class SharedStorageMock extends SharedStorageInterface {
    constructor() {
        super();
    }

    get = async (key=null) => {
        return undefined;
    }

    set = async (key, value) => {
        return this;
    }

    reset = async (key=null) => {
        return this;
    }

    subscribe = async (key, onChange) => {
        throw () => null;
    }
}

export default SharedStorageMock;